import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  categoriaSeleccionada: 0,
  categoriasPath: [],
  tipoVendedor: '',
  busca: '',
  estado: '',
  orden: 1, // 1: Más recientes, 2: Menor precio, 3: Mayor precio
  precioDesde: '',
  precioHasta: '',
  filtrosCaracteristicas: {},
  filtrosSeleccionados: {},
  publicacionesFiltradas: []
}

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setCategoria: (state, action) => {
      const { id, label } = action.payload
      state.categoriasPath.push({ id, label })
      state.categoriaSeleccionada = id
    },
    goBackToCategoria: (state, action) => {
      const id = action.payload
      const index = state.categoriasPath.findIndex((c) => c.id === id)
      if (index !== -1) {
        state.categoriasPath = state.categoriasPath.slice(0, index + 1)
        state.categoriaSeleccionada = id
        state.busca = ''
        state.filtrosCaracteristicas = {}
        state.filtrosSeleccionados = {}
      }
    },
    resetCategorias: (state) => {
      state.categoriasPath = []
      state.categoriaSeleccionada = 0
      state.busca = ''
      state.filtrosCaracteristicas = {}
      state.filtrosSeleccionados = {}
    },
    setCategoriaPath: (state, action) => {
      state.categoriasPath = action.payload
      state.categoriaSeleccionada = action.payload[action.payload.length - 1].id
    },
    setTipoVendedor: (state, action) => {
      state.tipoVendedor = action.payload
    },
    setBusca: (state, action) => {
      state.busca = action.payload
    },
    setEstado: (state, action) => {
      state.estado = action.payload
    },
    setOrden: (state, action) => {
      state.orden = Number(action.payload)
    },
    setPrecio: (state, action) => {
      const { desde, hasta } = action.payload
      state.precioDesde = desde
      state.precioHasta = hasta
    },
    setFiltrosCaracteristicas: (state, action) => {
      state.filtrosCaracteristicas = action.payload
    },
    setPublicacionesFiltradas: (state, action) => {
      state.publicacionesFiltradas = action.payload
    },
    setFiltrosSeleccionados: (state, action) => {
      state.filtrosSeleccionados = action.payload
    }
  }
})

export const {
  setCategoria,
  goBackToCategoria,
  resetCategorias,
  setCategoriaPath,
  setTipoVendedor,
  setBusca,
  setEstado,
  setOrden,
  setPrecio,
  setFiltrosCaracteristicas,
  setPublicacionesFiltradas,
  setFiltrosSeleccionados
} = filtersSlice.actions
export default filtersSlice.reducer
